import { SupplierSubscriptionPlan } from '../../../types/SupplierGroupSubscriptionMessage';
import { Button } from '../../cdl/Button/Button';
import { Callout } from '../../cdl/Callout/Callout';
import { translate } from '../../common/helpers/translate.helper';
import { IconCircleArrowUp } from '../../common/icons/cdl/CircleArrowUp';
import { useSupplierSubscriptionPlanPromotion } from '../useSupplierSubscriptionPlanPromotion';
import { useSupplierSubscriptionPlans } from '../useSupplierSubscriptionPlans';

interface SupplierSubscriptionPlanUpgradeCalloutProps {
    plan: SupplierSubscriptionPlan;
}

export const SupplierSubscriptionPlanUpgradeCallout = ({ plan }: SupplierSubscriptionPlanUpgradeCalloutProps) => {
    const { canViewPlans, openPlans } = useSupplierSubscriptionPlans();
    const isBasic = plan === SupplierSubscriptionPlan.BASIC;
    const promotion = useSupplierSubscriptionPlanPromotion(canViewPlans && isBasic);
    if (!canViewPlans || plan === SupplierSubscriptionPlan.ENTERPRISE) {
        return null;
    }
    if (isBasic) {
        return (
            <Callout
                variant="accent"
                Icon={IconCircleArrowUp}
                heading={
                    promotion.isSpecialOfferActive
                        ? promotion.heading
                        : translate('supplierSubscriptionPlans.readyToUpgrade')
                }
                description={
                    promotion.isSpecialOfferActive
                        ? promotion.description
                        : translate('supplierSubscriptionPlans.comparePlansForGroup')
                }
            >
                <Button type="button" emphasis="high" onClick={openPlans}>
                    {translate('supplierSubscriptionPlans.viewPlans')}
                </Button>
            </Callout>
        );
    }
    return (
        <Callout
            Icon={IconCircleArrowUp}
            heading={translate('supplierSubscriptionPlans.upgradeToEnterprise')}
            description={translate('supplierSubscriptionPlans.contactSalesOptions')}
        >
            <Button type="button" onClick={openPlans}>
                {translate('supplierSubscriptionPlans.viewPlans')}
            </Button>
        </Callout>
    );
};
